$(function() {
  const openBtn = $(".c-refferal-flow .open-item")

  openBtn.click(function() {
    $(this).parent().toggleClass("opened")
  })
})
